import {
	type FieldPath,
	type FieldValues,
	type UseControllerProps,
	useController,
} from "react-hook-form";
import { FormFieldError } from "../FormFieldError";
import {
	MultiSelectDropdownInput,
	type MultiSelectDropdownInputProps,
} from "../inputs/MultiSelectDropdownInput";

export type FormMultiSelectDropdownProps<
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
> = UseControllerProps<TFieldValues, FieldPath<TFieldValues>, TTransformedValues> &
	Omit<MultiSelectDropdownInputProps, "value" | "onChange" | "error"> & {
		errorMessage?: string;
	};

export const FormMultiSelectDropdown = <
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
>({
	name,
	control,
	defaultValue,
	disabled,
	errorMessage,
	...inputProps
}: FormMultiSelectDropdownProps<TFieldValues, TTransformedValues>) => {
	const {
		field: { ref: _ref, value, onChange, onBlur },
		fieldState: { error },
	} = useController<TFieldValues, FieldPath<TFieldValues>, TTransformedValues>({
		name,
		control,
		defaultValue,
	});

	const handleChange = (next: string[]) => {
		onChange(next);
		onBlur();
	};

	return (
		<div className="relative w-full">
			<MultiSelectDropdownInput
				{...inputProps}
				disabled={disabled}
				value={value}
				onChange={handleChange}
				error={!!error}
			/>
			{!!error && <FormFieldError error={error} errorMessage={errorMessage} />}
		</div>
	);
};
